import { render, staticRenderFns } from "./RecommendationsFeedbackCard.vue?vue&type=template&id=7e2a128e&scoped=true"
import script from "./RecommendationsFeedbackCard.vue?vue&type=script&lang=ts"
export * from "./RecommendationsFeedbackCard.vue?vue&type=script&lang=ts"
import style0 from "./RecommendationsFeedbackCard.vue?vue&type=style&index=0&id=7e2a128e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2a128e",
  null
  
)

export default component.exports